export const GENERATE_TOOLBAR_FIELDS = 'GENERATE_TOOLBAR_FIELDS';
export const SET_TOOLBAR_VALUE = 'SET_TOOLBAR_VALUE';
